module.exports = {
  email: 'sten@flii.nl',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://linkedin.com/in/sten-bossong',
    },
    {
      name: 'Website',
      url: 'https://flii.nl',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/sten.10/',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/@stenn10',
    },
  ],

  navLinks: [
    {
      name: 'Over',
      url: '/#about',
    },
    {
      name: 'Ervaring',
      url: '/#jobs',
    },
    {
      name: 'Projecten',
      url: '/#featured',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
